import { SalseOrgDetails } from "@dana/Services/StandardReturnDetailsService";
import StandardReturnOrderState from "@dana/Store/Data/StandardReturns/StandardReturnOrderState";
import { SystemListValuesModel } from "@dana/Types/ApiModels";
import {
    ApiParameter,
    get,
    patch,
    post,
    ServiceResult
} from "@insite/client-framework/Services/ApiService";
import { BaseModel, CarrierDto, OrderLineModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

export interface UpdateStandardReturnStateParameter extends StandardReturnOrderState {
}
export type SubmitReturnStatus = "IDLE" | "SUBMITTING" | "FAILED" | "SUCCESS";
/* Updated Dispositions */
export type DispositionPreference =
    | "SCRAP_AT_DANA_LOCATION"
    | "RETURN_FREIGHT_COLLECT_TO_YOUR_LOCATION"
    | "CONTACT_CUSTOMER_OPERATIONS";

/** Updated Return Reasons */
export type ReturnReason =
    | "CUSTOMER_SERVICE_ERROR"
    | "END_CUSTOMER_CANCEL"
    | "CS_KEYING_ERROR"
    | "WRONG_PART_ORDERED"
    | "PART_NO_LONGER_NEEDED";

export type WizardStepKey =
    | "SELECT_ITEMS"
    | "CONFIRM_ITEMS"
    | "REASON_DISPOSITION"
    | "INTERNAL_REF_ONLY"
    | "SHIPPING_CONTACT"
    | "FREIGHT_COLLECT"
    | "EMAIL_CONTACTS"
    | "REVIEW"
    | "SUBMIT_RESULT";


export interface StandardReturnOrderApiParameter extends ApiParameter {
    orderNumber?: string;
}
export interface ReturnOrderLineModel extends OrderLineModel {
    productId: string;
    minimumOrderQty: number;
    multipleSaleQty: number;
    maximumOrderQty: number;
    isReturnable?: boolean | null;
    return?: boolean | null;
    returnItemQty: number;
}
export interface FreightCollectInfo {
    customerName: string;
    country: string;
    zipCode?: string;
    state?: string;
    city?: string;
    address1?: string;
    address2?: string;
    freightHandling?: string;
    carrier?: string;
    carrierAccountNo?: string;
    shippingInstructions?: string;
    internalRefNo?: string;
}

export interface ShippingContact {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}

export interface ShippingContact {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}


export interface SubmitStandardReturnOrderApiParameter extends BaseModel {
    reason?: string;
    disposition?: string;
    internalRefNumber?: string;
    emailContacts?: string[];
    freightCollectInfo?: FreightCollectInfo;
    shippingContact?: ShippingContact;
    selectedItems: ReturnOrderLineModel[];
    originalOrderNumber: string;
    order: OrderModel
}

export interface ReturnOrderModel extends OrderModel {
    returnOrderLines: ReturnOrderLineModel[];
    primaryPoNumber: string;
    secondaryPoNumber: string;
}
export interface StandardReturnResult {
    returnOrderModel: ReturnOrderModel
    carrier: CarrierDto;
    dispositionPreferences?: SystemListValuesModel[];
    standardReturnReasons?: SystemListValuesModel[];
}
export interface StandardReturnSubmitResult extends BaseModel {
    orderNumber: string,
    salseOrgDetails: SalseOrgDetails
}
export interface StandardReturnsSendInquiryParameter extends ApiParameter {
    message?: string;
    recipients?: string[];
    userName?: string;
    ccRecipient?: string;
    type?: string
}

const standardReturnUrl = "api/v2/dana/standardReturn";

export async function getStandardReturnOrderApi(parameter: StandardReturnOrderApiParameter) {
    const account = await get<StandardReturnResult>(`${standardReturnUrl}`, parameter);
    return account;
}

export async function submitStandardReturnOrderApi(parameter: SubmitStandardReturnOrderApiParameter) {

    const accountModel = await patch<StandardReturnSubmitResult>(`${standardReturnUrl}?IsStandardReturnsOrder=true`, parameter);
    return accountModel;

}
export async function submitStandardReturnOrderResult(
    parameter: SubmitStandardReturnOrderApiParameter,
): Promise<ServiceResult<StandardReturnSubmitResult>> {
    try {
        const updatedAccount = await submitStandardReturnOrderApi(parameter);
        return {
            successful: true,
            result: updatedAccount,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }


}
export async function sendStandardReturnInquiry(parameter: StandardReturnsSendInquiryParameter) {
    try {
        const result = await post<StandardReturnsSendInquiryParameter, boolean>(`${standardReturnUrl}/sendInquiry`, parameter);
        return result;
    } catch (error) {
        console.log(error);
        return false;
    }
}